import React from 'react';
import { useSelector } from 'react-redux';

import useAverageByDataType from './useAverageByDataType';
import { RESONANCE_CONCEPT_DATA_TYPES } from '../../../../../../constants';
import getAverageAnnotations from '../../../../../../utils/getAverageAnnotations';
import VerticalBars from '../../../../../../components/charts/chartjs/vertical-bars/VerticalBars';
import VerticalBarTooltipLabels from '../../../../../../components/charts/chartjs/vertical-bars/vertical-bar-tooltip-labels/VerticalBarTooltipLabels';
import { getChartValueColor } from '../../../../../../utils/chart';
import useConceptDatasets from './useConceptDatasets';
import createTooltipMarkup from '../tooltip-markup/tooltipMarkup';

import scss from './ConceptChart.module.scss';

function OriginalConceptChart({ selectedConcept, compareConcepts, isGlobalPercentage }) {
  const theme = useSelector((state) => state.global.theme);

  const averages = useAverageByDataType(RESONANCE_CONCEPT_DATA_TYPES.ORIGINAL, isGlobalPercentage);

  const datasets = useConceptDatasets({
    selectedConcept,
    compareConcepts,
    dataType: RESONANCE_CONCEPT_DATA_TYPES.ORIGINAL,
    isGlobalPercentage,
  });

  const chartLabels = averages?.map((average) => average.name) ?? [];

  const chartsConfig = {
    options: {
      plugins: {
        legend: {
          display: true,
        },
      },
    },
    tooltip: {
      createMarkup: (tooltipModel, data) => createTooltipMarkup({ tooltipModel, data, averages }),
    },
    datalabels: {
      anchor: 'center',
      align: 'center',
      color: getChartValueColor(theme),
      font: {
        size: '12px',
        weight: 'bold',
        family: 'Inter',
      },
      formatter: function (value) {
        return value ? value + '%' : '';
      },
    },
    scales: {
      x: {
        ticks: {
          display: false,
        },
      },
    },

    annotations: getAverageAnnotations({ averages }),
  };

  return (
    <div className={scss.wrapper}>
      <VerticalBars
        height={'300px'}
        data={{
          labels: chartLabels,
          datasets: datasets,
        }}
        config={chartsConfig}
      />
      <VerticalBarTooltipLabels labels={chartLabels} />
    </div>
  );
}

export default OriginalConceptChart;
